/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmEvalsGetRun } from "../../funcs/llmEvalsGetRun.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetEvalRunRequest$inboundSchema,
};

export const tool$llmEvalsGetRun: ToolDefinition<typeof args> = {
  name: "llm-evals-get-run",
  description: `Get an eval run

Retrieves an eval run by ID.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmEvalsGetRun(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
